(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.campaign-video').forEach(video=>{
 const button=video.parentElement.querySelector('.campaign-video-toggle');
 const sync=()=>{button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);button.querySelector('span').textContent=video.paused?'▶':'Ⅱ';};
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();
 button.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause();});
 video.addEventListener('play',sync);video.addEventListener('pause',sync);sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lmp-reviews').forEach(section=>{section.querySelectorAll('[data-review-direction]').forEach(button=>button.addEventListener('click',()=>{const track=section.querySelector('.lmp-review-track');const card=track.querySelector('.lmp-review-card');track.scrollBy({left:(card.getBoundingClientRect().width+20)*Number(button.dataset.reviewDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happiness-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.happiness-video').forEach(frame=>{
  const video=frame.querySelector('video');
  const button=frame.querySelector('.happiness-toggle');
  const sync=()=>{
    button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);
    button.querySelector('span').textContent=video.paused?'▶':'Ⅱ';
  };
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();
  button.addEventListener('click',()=>{
    if(video.paused)video.play().catch(sync);else video.pause();
  });
  video.addEventListener('play',sync);
  video.addEventListener('pause',sync);
  sync();
});

  } catch(e) { console.error(e); }
})();
})();
